import { Stack, Breadcrumbs, Link } from '@mui/material'
import { useParams, useLocation, Link as RouterLink } from 'react-router-dom'
import Page from '../components/Page'
import ReportApp from './ReportApp'
import { ReactComponent as RightAngle } from "../assets/icons/icon-angle-right.svg";
import { useEffect, useState } from 'react';
import { getAllFolders } from '../config/services/reportFolder';

export default function ReportFolderApp() {
    const [folderName, setFolderName] = useState('');
    const UrlParams = useParams()
    let { id } = UrlParams
    // const search = useLocation().search;
    // const folderName = new URLSearchParams(search).get('folderName')
    const fetchFoldersList = async () => {
        let params = {currentFolderId: undefined}
        let response = await getAllFolders(params)
        if (response?.result) {
            response?.result.forEach(obj => {
                if (obj._id === id) {
                    setFolderName(obj.folderName)
                }
            });
        }
    }

    useEffect(() => fetchFoldersList(), [])

    return (
        <Page title="Extramarks | Reports ">
            {
                (folderName != 'null') ?
                    <Stack spacing={2} pl={3}>
                        <Breadcrumbs separator={<RightAngle />} aria-label="breadcrumb" className="breadcrumb">                    
                            <Link underline="hover" key="1" color="inherit" component={RouterLink} to="/report" className="breadcrumbs_item_link">Reports</Link>
                            <Link aria-current="page" color="inherit" className="breadcrumbs_item_current">{folderName}</Link>
                        </Breadcrumbs>
                    </Stack>
                : null
            }
            
            <ReportApp folderId={id} folderName={folderName} />
        </Page>
    )
}
